import { RouteConfig } from "vue-router";

const DefaultLayout = () => import("~shared/layouts/DefaultLayout.vue");
const UsersIndex = () => import("@/modules/users/pages/UsersIndex.vue");
const UsersShow = () => import("@/modules/users/pages/UsersShow.vue");

export const routes: RouteConfig[] = [
  {
    path: "/users",
    component: DefaultLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        component: UsersIndex,
        name: "UsersIndex",
      },
      {
        path: ":userId",
        component: UsersShow,
        name: "UsersShow",
      },
    ],
  },
];
